import { register_components } from './components'

register_components()

export const customLabel = [
  {
    name: '温度', // 工具栏提示文字
    image: '/materials/png/wendu.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '温度'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '℃'
        }
      }
    }
  },
  {
    name: '电压', // 工具栏提示文字
    image: '/materials/png/idianya.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '电压'
        },
        endText: {
          fontSize: '12',
          text: 'V'
        }
      }
    }
  },
  {
    name: '电流', // 工具栏提示文字
    image: '/materials/png/idianliu.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '电流'
        },
        endText: {
          fontSize: '12',
          text: 'A'
        }
      }
    }
  },
  {
    name: '屏蔽层电流', // 工具栏提示文字
    image: '/materials/png/idianliupbc.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '屏蔽层电流'
        },
        endText: {
          fontSize: '12',
          text: 'A'
        }
      }
    }
  },
  {
    name: '铠甲层电流', // 工具栏提示文字
    image: '/materials/png/idianliukjc.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '铠甲层电流'
        },
        endText: {
          fontSize: '12',
          text: 'A'
        }
      }
    }
  },
  {
    name: '主芯电流', // 工具栏提示文字
    image: '/materials/png/idianliux.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '芯电流'
        },
        endText: {
          fontSize: '12',
          text: 'A'
        }
      }
    }
  },
  {
    name: '端电压', // 工具栏提示文字
    image: '/materials/png/idianyad.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '端电压'
        },
        endText: {
          fontSize: '12',
          text: 'V'
        }
      }
    }
  },
  {
    name: '阀芯温度', // 工具栏提示文字
    image: '/materials/png/iwendufaxin.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '阀芯温度'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '℃'
        }
      }
    }
  },
  {
    name: '动作次数', // 工具栏提示文字
    image: '/materials/png/idongzuo.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '动作次数'
        },
        endText: {
          fontSize: '12',
          text: ''
        }
      }
    }
  },
  {
    name: '有功', // 工具栏提示文字
    image: '/materials/png/iyougong.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '有功'
        },
        endText: {
          fontSize: '12',
          text: 'kW'
        }
      }
    }
  },
  {
    name: '无功', // 工具栏提示文字
    image: '/materials/png/iwugong.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '无功'
        },
        endText: {
          fontSize: '12',
          text: 'kVar'
        }
      }
    }
  },
  {
    name: '频率', // 工具栏提示文字
    image: '/materials/png/ipinlv.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '频率'
        },
        endText: {
          fontSize: '12',
          text: 'Hz'
        }
      }
    }
  },
  {
    name: '液位', // 工具栏提示文字
    image: '/materials/png/yewei.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '液位'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'm'
        }
      }
    }
  },
  {
    name: 'PH', // 工具栏提示文字
    image: '/materials/png/ph.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'PH'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: ''
        }
      }
    }
  },
  {
    name: '氨氮', // 工具栏提示文字
    image: '/materials/png/andan.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '氨氮'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'mg/L'
        }
      }
    }
  },
  {
    name: 'COD', // 工具栏提示文字
    image: '/materials/png/cod.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'COD'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'mg/L'
        }
      }
    }
  },
  {
    name: '总磷', // 工具栏提示文字
    image: '/materials/png/zonglin.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '总磷'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'mg/L'
        }
      }
    }
  },
  {
    name: '总氮', // 工具栏提示文字
    image: '/materials/png/zongdan.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '总氮'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'mg/L'
        }
      }
    }
  },
  {
    name: '浓度', // 工具栏提示文字
    image: '/materials/png/nongdu.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '浓度'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'mg/L'
        }
      }
    }
  },
  {
    name: '压力KPa', // 工具栏提示文字
    image: '/materials/png/yali.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '压力'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'KPa'
        }
      }
    }
  },
  {
    name: '压力MPa', // 工具栏提示文字
    image: '/materials/png/yali_2.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          fontColor: '#000000',
          text: '压力'
        },
        endText: {
          fontSize: '12',
          fontColor: '#000000',
          text: 'MPa'
        }
      }
    }
  },
  {
    name: '流量', // 工具栏提示文字
    image: '/materials/png/liuliang.svg', //  图片URL 与上面 icon 二选一即可
    data: {
      text: '#.#', // 拖拽出现后现在在图形中心文字
      rect: {
        // 宽高必填项
        width: 64,
        height: 18
      },
      name: 'customRectangle', // 该值作为水池的统一标识
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 0.1,
      strokeStyle: 'transparent',
      fillStyle: '#4A90E2',
      fontColor: '#fff',
      data: {
        preText: {
          fontSize: '12',
          text: '流量'
        },
        endText: {
          fontSize: '12',
          text: 'm³/h'
        }
      }
    }
  }
]

export const cumtomIot = [
  {
    name: '输入框',
    icon: 't-icon t-shurukuang',
    data: {
      rect: {
        width: 200,
        height: 40
      },
      activeTextColor: '#000000FF',
      borderRadius: 0.05,
      color: '#D9D9D9FF',
      disableAnchor: true,
      ellipsis: true,
      height: 40,
      hoverTextColor: '#000000FF',
      input: true,
      name: 'rectangle',
      text: '输入数据',
      textAlign: 'left',
      textColor: '#000000FF',
      textLeft: 10,
      width: 200
    }
  },
  {
    name: '按钮',
    icon: 't-icon t-anniu',
    data: {
      rect: {
        width: 80,
        height: 30
      },
      fillStyle: '#40a9ff',
      strokeStyle: '#40a9ff',
      fontColor: '#ffffff',
      textColor: '#ffffff',
      borderRadius: 2,
      color: '#1890ff',
      disableAnchor: true,
      height: 30,
      hoverBackground: '#40a9ff',
      hoverColor: '#40a9ff',
      hoverTextColor: '#ffffff',
      name: 'rectangle',
      text: '按钮',
      textColor: '#ffffff',
      width: 80
    }
  },
  {
    name: '开关',
    icon: 't-icon t-kaiguan',
    data: {
      rect: {
        width: 60,
        height: 30
      },
      name: 'switchobj',
      value: true,
      value: true,
      disableAnchor: true,
      disableOffColor: '#E5E5E5',
      disableOnColor: '#A3D3FF',
      height: 30,
      hoverBackground: '#40a9ff',
      offColor: '#BFBFBF',
      onColor: '#1890ff',
      width: 60,
      events: [
        {
          type: 0,
          action: 2,
          name: 'click',
          value: 'window.topology.setValue({id:pen.id,value:!pen.value});'
        }
      ]
    }
  },
  {
    name: '进度条',
    icon: 't-icon t-jindutiao',
    data: {
      rect: {
        width: 300,
        height: 20
      },
      name: 'slider',
      anchors: [],
      textAlign: 'right',
      background: '#D4D6D9',
      fillStyle: '#1890FF',
      strokeStyle: '#1890FF',
      barHeight: 4,
      color: '#1890ff',
      textLeft: 0,
      barRect: {},
      disableAnchor: true,
      data: [
        {
          key: 'unit',
          value: '%'
        }
      ],
      height: 20,
      max: 100,
      min: 0,
      name: 'slider',
      textColor: '#222222',
      textWidth: 50,
      unit: '%',
      value: 10,
      width: 300
    }
  },
  {
    data: {
      rect: {
        width: 300,
        height: 20
      },
      fillStyle: '#000000',
      strokeStyle: '#000000',
      data: [
        ['设备 ID', '设备名称', '数据协议', '状态'],
        ['1', '200', 'MQTT', '正在运行'],
        ['2', '湿度传感器', 'MQTT', '正在运行'],
        ['3', '物联网设备', 'MQTT', '正在运行'],
        ['4', '物联网设备/智能家居/智慧城市', 'MQTT', '正在运行']
      ],
      disableAnchor: true,
      height: 0,
      name: 'table',
      rowHeight: 40,
      styles: [
        {
          background: '#ffff00',
          col: 1,
          color: '#ffff00',
          row: 1,
          wheres: [{ comparison: '<=', value: '123' }]
        },
        {
          height: 60,
          row: 0
        },
        {}
      ],
      width: 0
    },
    icon: 't-icon t-biaoge',
    name: '表格'
  },
  {
    name: 'thermometer',
    icon: 't-icon t-wenduji',
    data: {
      rect: {
        width: 100,
        height: 300
      },
      name: 'thermometer',
      width: 100,
      height: 300,
      disableAnchor: !0,
      fillStyle: '#faad14',
      value: 10,
      min: -40,
      max: 40,
      data: [
        {
          key: '最小值',
          name: 'min',
          type: 'number',
          value: -20
        },
        {
          key: '最大值',
          name: 'max',
          type: 'number',
          value: 20
        }
      ]
    }
  },
  {
    name: 'watermeter',
    icon: 't-icon t-shuiliujianceqi',
    data: {
      rect: {
        width: 100,
        height: 100
      },
      name: 'watermeter',
      width: 100,
      height: 100,
      disableAnchor: !0,
      fillStyle: '#faad14',
      value: 50,
      max: 70,
      min: 20,
      maxBackground: '#f5222d',
      minBackground: '#52c41a',
      scaleShow: !1,
      data: [
        {
          key: '最大值',
          name: 'max',
          type: 'number',
          value: 70
        },
        {
          key: '最小值',
          name: 'min',
          type: 'number',
          value: 20
        },
        {
          key: '最大值背景',
          name: 'maxBackground',
          value: '#f5222d'
        },
        {
          key: '最小值背景',
          name: 'minBackground',
          value: '#52c41a'
        },
        {
          key: '显示刻度',
          name: 'scaleShow',
          type: 'switch',
          value: !1
        },
        {
          key: '最大值文字',
          name: 'maxText',
          value: '最大值'
        },
        {
          key: '最小值文字',
          name: 'minText',
          value: '最小值'
        }
      ]
    }
  },
  {
    name: '指示灯',
    icon: 't-icon t-tuxingzhishideng1',
    data: {
      rect: {
        width: 100,
        height: 100
      },
      name: 'indicatorLight',
      width: 100,
      height: 100,
      displayStatus: 0,
      value: 0,
      fillStyle: '#5ac8f7',
      strokeStyle: '#5ac8f7',
      hiddenText: !0,
      data: [
        {
          key: '显示状态',
          name: 'displayStatus',
          type: 'select',
          options: [
            {
              label: '默认',
              value: 0
            },
            {
              label: '方形',
              value: 1
            },
            {
              label: '圆形',
              value: 2
            }
          ]
        }
      ],
      frames: [
        {
          background: '#f53e6c',
          color: '#f53e6c',
          bkType: 0,
          duration: 200,
          strokeType: 0,
          visible: !0
        },
        {
          background: '#5ac8f7',
          color: '#5ac8f7',
          bkType: 0,
          duration: 200,
          strokeType: 0,
          visible: !0
        }
      ],
      animateType: 'custom'
    }
  },
  {
    name: '拨动开关',
    icon: 't-icon t-bodongkaiguan',
    data: {
      rect: {
        width: 100,
        height: 100
      },
      name: 'toggleSwitch',
      width: 100,
      height: 100,
      value: !1,
      color: '#0AECA140',
      background: '#748E9140',
      events: [
        {
          type: 0,
          action: 2,
          name: 'click',
          value: 'window.topology.setValue({id:pen.id,value:!pen.value});'
        }
      ]
    }
  },
  {
    name: '闸刀',
    icon: 't-icon t-zhadao',
    data: {
      rect: {
        width: 100,
        height: 100
      },
      name: 'knifeSwitch',
      width: 100,
      height: 100,
      value: !1,
      color: '#0AECA140',
      background: '#748E9140',
      events: [
        {
          type: 0,
          action: 2,
          name: 'click',
          value: 'window.topology.setValue({id:pen.id,value:!pen.value});'
        }
      ]
    }
  }
]
